var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-settings",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.5,
    height: 17.729,
    viewBox: "0 0 18.5 17.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14494",
    "data-name": "Grupo 14494",
    transform: "translate(0 12.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14493",
    "data-name": "Grupo 14493"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5204",
    "data-name": "Caminho 5204",
    d: "M17.729,353.927H15.676a2.68,2.68,0,0,0-5.145,0H.771a.771.771,0,0,0,0,1.542h9.761a2.68,2.68,0,0,0,5.145,0h2.053a.771.771,0,0,0,0-1.542ZM13.1,355.854A1.156,1.156,0,1,1,14.26,354.7,1.158,1.158,0,0,1,13.1,355.854Z",
    transform: "translate(0 -352)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14496",
    "data-name": "Grupo 14496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14495",
    "data-name": "Grupo 14495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5205",
    "data-name": "Caminho 5205",
    d: "M17.729,12.594H15.676a2.68,2.68,0,0,0-5.145,0H.771a.771.771,0,1,0,0,1.542h9.761a2.68,2.68,0,0,0,5.145,0h2.053a.771.771,0,0,0,0-1.542ZM13.1,14.521a1.156,1.156,0,1,1,1.156-1.156A1.158,1.158,0,0,1,13.1,14.521Z",
    transform: "translate(0 -10.667)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14498",
    "data-name": "Grupo 14498",
    transform: "translate(0 6.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14497",
    "data-name": "Grupo 14497"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5206",
    "data-name": "Caminho 5206",
    d: "M17.729,183.261H7.968a2.68,2.68,0,0,0-5.145,0H.771a.771.771,0,0,0,0,1.542H2.824a2.68,2.68,0,0,0,5.145,0h9.761a.771.771,0,0,0,0-1.542ZM5.4,185.188a1.156,1.156,0,1,1,1.156-1.156A1.158,1.158,0,0,1,5.4,185.188Z",
    transform: "translate(0 -181.334)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSettings);
export default __webpack_public_path__ + "static/media/ico-settings.18f4dcce26b6b0f6762a10864566efd6.svg";
export { ForwardRef as ReactComponent };